import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PromoList.css";
import { db } from "../firebase"; // <-- ton fichier firebase.js
import { collection, getDocs, limit, query, where } from "firebase/firestore";
import { useCart } from "../CartProvider";
import { MdInfoOutline } from "react-icons/md";
import { FaWhatsapp, FaTiktok, FaPhoneAlt, FaInstagram } from "react-icons/fa";

import ModalDetail from "./ModalDetail";

/**
 * Map de colonnes Firestore -> format UI attendu
 * Adapte les valeurs à tes champs:
 *  - exemple: titleField: "name" si dans Firestore c'est "name"
 */
const COLUMN_MAP = {
  idField: "id",              // si tes docs ont un champ id custom; sinon on utilisera doc.id
  titleField: "Name",
  categoryField: "category",
  imageField: "ImageUrl",        // URL vers image principale
  priceField: "Stores",
  oldPriceField: "oldPrice",
  // facultatif: un booléen/flag dans Firestore pour afficher "Sale!"
  saleField: "onSale",
};

/** Transforme un doc Firestore → objet produit normalisé pour l'UI */
function normalizeProduct(doc, map) {
  const d = doc.data ? doc.data() : doc; // robuste si on passe déjà un objet
  const id = d?.[map.idField] ?? doc.id; // priorité au champ, sinon doc.id
  return {
    id,
    title: d?.[map.titleField] ?? "Untitled",
    category: (d?.[map.categoryField] ?? "").toString(),
    image: d?.[map.imageField] ?? "",
    price: Number(d?.PromoPrice?.PromoPrice ?? 0),
    normalPrice: Number(d?.PromoPrice?.NormalPrice ?? 0),
    oldPrice: Number(d?.[map.oldPriceField] ?? 0),
    stock: Number(d?.PromoPrice?.Quantity ?? 0),
    onSale: Boolean(d?.[map.saleField] ?? false),
    IsPack: Boolean(d?.HasChilds ?? false),
    Images: d?.Images ?? [],
    Description: d?.Description ?? "Pas de description...",
    SubCategorie: d?.Categorie?.SubCategorie?.Id ?? null,
    ParentId: (d?.ParentId == null || String(d.ParentId).trim() === '') ? doc.id : d.ParentId , 
    MaxiDiscount: Number(d?.MaxiDiscount ?? 0),
    GetDiscount: Boolean(d?.GetDiscount ?? false),
    ApplyInvitation: Boolean(d?.ApplyInvitation ?? false),
  };
}

const formatFCFA = (n) =>
  new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Number(n || 0));

export default function PromoList({getType}) {
  const { cart, addToCart, inc, dec } = useCart();
    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false);
        const [myData , setMyData] = useState([]);
  
  // ------- state produits (depuis Firestore) -------
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  // ------- cart local par id -------

  // Charger 48 items depuis Firestore
  useEffect(() => {
    let mounted = true;

    async function fetchProducts(cat) {
      if(cat != null){
       try {
        setLoading(true);
        setErr("");

        // Tri optionnel pour stabilité d’affichage (par ex. par title)
        const q = query(
          collection(db, "items"),
          where("Categorie.Id", "==" , cat.id),
          limit(120)
        );

        const snap = await getDocs(q);
        if (!mounted) return;

        const list = snap.docs.map((doc) => normalizeProduct(doc, COLUMN_MAP));
        setProducts(list);
      } catch (e) {
        console.error(e);
        setErr("Impossible de charger les produits.");
      } finally {
        if (mounted) setLoading(false);
      }
      }
      else{
        try {
        setLoading(true);
        setErr("");

        // Tri optionnel pour stabilité d’affichage (par ex. par title)
        const q = query(
          collection(db, "items"),
          where("InPromo", "==" , true),
          limit(120)
        );

        const snap = await getDocs(q);
        if (!mounted) return;

        const list = snap.docs.map((doc) => normalizeProduct(doc, COLUMN_MAP));
        setProducts(list);

        window.scrollTo({
  top: 0,
  behavior: 'smooth'
});
      } catch (e) {
        console.error(e);
        setErr("Impossible de charger les produits.");
      } finally {
        if (mounted) setLoading(false);
      }
      }
    }

    fetchProducts(getType);
    return () => {
      mounted = false;
    };
  }, [getType]);

  // Helpers panier (autoriser 0 pour revenir à l’état initial)
  // const addToCart = (id) => setCart((c) => ({ ...c, [id]: 1 }));
  // const inc = (id, stock) =>
  //   setCart((c) => ({ ...c, [id]: Math.min((c[id] ?? 0) + 1, stock) }));
  // const dec = (id) =>
  //   setCart((c) => {
  //     const next = Math.max((c[id] ?? 0) - 1, 0);
  //     if (next === 0) {
  //       const { [id]: _omit, ...rest } = c;
  //       return rest; // supprime la clé → re-affiche "Add to Cart"
  //     }
  //     return { ...c, [id]: next };
  //   });

  const content = useMemo(() => {
    if (loading) {
      // squelette simple
      return (
        <div className="grid-pl">
          {Array.from({ length: 8 }).map((_, i) => (
            <article key={i} className="card-pl" aria-busy="true">
              <div className="card-media-pl" style={{ background: "#f3f4f6" }} />
              <div className="card-body-pl">
                <p className="category-pl" style={{ background: "#f3f4f6", height: 12, width: "60%" }} />
                <p className="title-pl" style={{ background: "#f3f4f6", height: 16, width: "80%" }} />
                <div className="price-row-pl" style={{ background: "#f3f4f6", height: 14, width: "50%" }} />
                <button className="add-btn-pl" disabled>Chargement...</button>
              </div>
            </article>
          ))}
        </div>
      );
    }
    if (err) {
      return <p style={{ color: "#b91c1c" }}>{err}</p>;
    }
    if (!products.length) {
      return <p>Aucun produit disponible.</p>;
    }

    const handleDetails = (item) => {
    navigate(`/details/${item.id}`, { state: { item } });
  };

    return (
      <div className="grid-pl">
        {products.map((p, idx) => {
          const qty = cart[p.id]?.qty ?? 0;
          const inCart = qty > 0;

          return (
            <article key={p.id} className="card-pl">
              <div className="card-media-pl">
                {/* image fallback si vide */}
                <img
                  src={p.image || "https://via.placeholder.com/800x600?text=No+image"}
                  alt={p.title}
                  loading="lazy"
                  onClick={() => handleDetails(p)}
                />
               <button 
               className="wish-pl" 
               aria-label="Plus de détails" 
               onClick={(e) => {
                  e.stopPropagation(); // empêche le clic de remonter jusqu'à l'image
                  setMyData(p);
                  setIsOpen(true);
                }}
               >
                  <MdInfoOutline size={14} aria-hidden="true" />
                </button>

                {(p.onSale || idx === 1 || p.id % 5 === 0) && (
                  <span className="badge-pl">Sale!</span>
                )}
                {p.IsPack  && (
                  <span className="badge-pl">Paquet</span>
                )}
              </div>

              <div className="card-body-pl">
                <p className="category-pl">{(p.category || "").toUpperCase()}</p>

                <p className="title-pl" title={p.title}>
                  {p.title}
                </p>

                {/* rating + reviews (fixe pour la maquette) */}
                <div className="rating-row-pl">
                </div>

                {/* prix */}
                <div className="price-row-pl">
                  <span className="price-pl">
                    {formatFCFA(p.price)} FCFA
                  </span>
                  {!!p.normalPrice && (
                    <span className="old-price-pl">
                      {formatFCFA(p.normalPrice)} FCFA
                    </span>
                  )}
                </div>

                {/* CTA zone */}
                {!inCart ? (
                  p.stock > 0
                  ?
                  <button className="add-btn-pl" onClick={() => addToCart(p.id , p)}>
                    <span className="cart-ico-pl" aria-hidden="true">+</span>
                    Add to Cart
                  </button>
                  :
                  <button className="add-btn-pl">
                    <span  aria-hidden="true"><FaWhatsapp size={20} /></span>
                    Whatsapp
                  </button>
                ) : (
                  <>
                    <div className="qty-wrap-pl">
                      <span className="qty-label-pl">Quantity</span>
                      <div className="qty-ctrl-pl">
                        <button onClick={() => dec(p.id)} aria-label="Decrease">−</button>
                        <span style={{ margin: "0 8px" }}>{qty}</span>
                        <button onClick={() => inc(p.id, p.stock)} aria-label="Increase">+</button>
                      </div>
                    </div>

                    <div className="subtotal-pl">
                      <span>{window.innerWidth >= 600 ? "Sous total" : "Total"}</span>
                      <strong>
                        {formatFCFA((qty * p.price))} FCFA
                      </strong>
                    </div>
                  </>
                )}
              </div>
            </article>
          );
        })}
      </div>
    );
  }, [products, cart, loading, err]);

  return (
    <>
    <section className="product-list-pl">
      {content}

      
    </section>
    <ModalDetail isOpen={isOpen} onClose={() => setIsOpen(false)} myProducts={myData}/>
    </>
  );
}
